// extracted by mini-css-extract-plugin
export default {"anchor":"style_anchor__iGuu0","clip":"style_clip__uVO3t","circle":"style_circle__wSPI-","arrow":"style_arrow__IvOHP","spinner":"style_spinner__yw7db","spin":"style_spin__ZoH0R"};